import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-line" />
      <div className="container">
        <div className="footer-inner">
          <div className="footer-brand">
            <img src="/logo.jpg" alt="KroMaker" />
            <span>KroMaker</span>
          </div>
          <p className="footer-tagline">
            Forgiamo il futuro tra luce, materia e tecnologia
          </p>
          <div className="footer-links">
            <a href="#services">Servizi</a>
            <a href="#projects">Progetti</a>
            <a href="#blog">Blog</a>
            <a href="#contact">Contatti</a>
          </div>
          <p className="footer-copy">
            © 2026 KroMaker · kromaker.it · Tutti i diritti riservati
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
